/** Whether this is a phone or tablet, where the file input opens the device's own camera app. */
export function hasNativeCamera(): boolean {
  return typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;
}

/** What to call this device in an expense's history. */
export function deviceName(): "Phone" | "Desktop" {
  return hasNativeCamera() ? "Phone" : "Desktop";
}

/** Whether the browser can show a live camera here (it needs a secure page). */
export function canUseCamera(): boolean {
  return (
    typeof navigator !== "undefined" && typeof navigator.mediaDevices?.getUserMedia === "function"
  );
}
